// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectionsCatalog_container__QBba_","productList":"SelectionsCatalog_productList__7uY03","load":"SelectionsCatalog_load__1bzty"};